var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4436 22.75V20.5833C21.4436 19.4341 20.9987 18.3319 20.2069 17.5192C19.4151 16.7065 18.3412 16.25 17.2214 16.25H8.77691C7.65711 16.25 6.58317 16.7065 5.79135 17.5192C4.99953 18.3319 4.55469 19.4341 4.55469 20.5833V22.75",
    stroke: "#EAEAEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9996 11.9167C15.3314 11.9167 17.2218 9.97657 17.2218 7.58333C17.2218 5.1901 15.3314 3.25 12.9996 3.25C10.6677 3.25 8.77734 5.1901 8.77734 7.58333C8.77734 9.97657 10.6677 11.9167 12.9996 11.9167Z",
    stroke: "#EAEAEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f6bb334ed48e63b11d01c8cb54dd0621.svg";
export { ForwardRef as ReactComponent };